import store from '../store';
import currencyListEn from '../../assets/data/currenciesList_en.json';
import currencyListEs from '../../assets/data/currenciesList_es.json';
import {
	TYPE_SERVICES,
	MASK_SERVICE_TYPE,
	PENDING,
	UNCONFIRMED,
	WAITING_PAYMENT,
	ACCEPTED,
	ASSIGNED,
	RUNNING,
	TARGET_REACHED,
	FLAG_WORKING,
	COMPLETED,
	CANCELLED,
	POST_PAYMENT,
	BEING_PREPARED,
	PREPARED,
	READY_TO_COLLECT,
	COLLECTED,
	EXPIRED
} from '../../constants/bitwiseOperations';
import moment from 'moment';
import 'moment/locale/es'
import { DEFAULT_TIME_ZONE, COMPANY_ACCESS } from '../../constants/general';

// ############################### store imports

const { json_lang, session } = store.getState();


// ###############################

const statusCanceled = {
	text: json_lang.order_status.canceled,
	style: 'canceled',
	step: 'canceled',
	sortingWeight: 1500
}

const statusDelivered = {
	text: json_lang.order_status.delivered,
	style: 'delivered',
	step: 'delivered',
	sortingWeight: 1400
}

const statusInProgress = {
	text: json_lang.order_status.in_progress,
	style: 'ready',
	step: 'ready',
	sortingWeight: 1300
}

const statusArrived = {
	text: json_lang.order_status.arrived,
	style: 'ready',
	step: 'ready',
	sortingWeight: 1301 //1300 a delivery
}

const statusReady = {
	text: json_lang.order_status.ready,
	style: 'ready',
	step: 'ready',
	sortingWeight: 1302 //1300 a pickUp
}

const statusOnTheWay = {
	text: json_lang.order_status.on_the_way,
	style: 'on_the_way',
	step: 'on_the_way',
	sortingWeight: 1200
}
/*
const statusInProgress2 = {
	text: json_lang.order_status.provider_arrived,
	style: 'on_the_way',
	step: 'on_the_way',
	sortingWeight: 1212
}*/

const statusInCommerce = {
	text: json_lang.order_status.in_commerce,
	style: 'on_the_way',
	step: 'on_the_way',
	sortingWeight: 3000
}

const statusDelayed = {
	text: json_lang.order_status.delayed,
	style: 'delayed',
	step: 'delayed',
	sortingWeight: 1211
}

const statusScheduled = {
	text: json_lang.order_status.scheduled,
	style: 'confirmed',
	step: 'confirmed',
	sortingWeight: 1001 //1000
}

const statusConfirmed = {
	text: json_lang.order_status.confirmed,
	style: 'confirmed',
	step: 'confirmed',
	sortingWeight: 1000
}


const statusIsConfirmed = {
	text: json_lang.order_status.in_queue,
	style: 'confirmed',
	step: 'confirmed',
	sortingWeight: 1000
}

const statusNotStarted = {
	text: json_lang.order_status.not_started,
	style: 'confirmed',
	step: 'confirmed',
	sortingWeight: 1000
}

/*const statusProviderArrived = {
	text: json_lang.order_status.provider_arrived,
	style: 'confirmed',
	step: 'confirmed',
	sortingWeight: 1000
}*/
/////////////////////////////

const statusDispatched2 = {
	//text: json_lang.order_status.dispatched,
	text: json_lang.order_status.dispatched,
	style: 'delivered',
	step: 'delivered',
	sortingWeight: 1010
}

const statusBeingPrepared = {
	text: json_lang.order_status.preparation_started,
	style: 'confirmed',
	step: 'confirmed',
	sortingWeight: 1001
}

const statusExpired = {
	text: json_lang.order_status.expired,
	style: 'canceled',
	step: 'canceled',
	sortingWeight: 1003
}
const statusPrepared = {
	text: session.admin_type && session.admin_type.name === "Despachador" ? json_lang.order_status.is_ready : json_lang.order_status.prepared,
	style: session.admin_type && session.admin_type.name === "Despachador" ? 'ready' : 'confirmed',
	step: 'confirmed',
	sortingWeight: 1002
}

/*const statusDispatched = {
	text: session.admin_type && session.admin_type.name === "Despachador" ? json_lang.order_status.is_ready : json_lang.order_status.prepared,
	style: session.admin_type && session.admin_type.name === "Despachador" ? 'ready' : 'confirmed',
	step: 'confirmed',
	sortingWeight: 1002
}*/

const statusNotDelivered  = {
	text: json_lang.order_status.not_delivered,
	style: 'canceled',
	step: 'canceled',
	sortingWeight: 940
}
//////////////////////////////////////////
const statusPaymentPending = {
	text: json_lang.order_status.payment_pending,
	style: 'payment_pending',
	step: 'payment_pending',
	sortingWeight: 940
}

const statusPaymentRefusedInvalid = {
	text: json_lang.order_status.payment_refused_invalid,
	style: 'payment_refused',
	step: 'payment_refused',
	sortingWeight: 940
}

const statusPaymentRefusedDuplicated = {
	text: json_lang.order_status.payment_refused_duplicated,
	style: 'payment_refused',
	step: 'payment_refused',
	sortingWeight: 940
}
const statusPaymentMixed = (paymentType, title) => ({
	text: json_lang.order_status.payment_mixed,
	title: title,
	style: "mixed",
	step: `mixed ${paymentType.join(' ')}`,
	sortingWeight: 940
})

const statusPaymentCash = {
	text: json_lang.order_status.payment_cash,
	style: 'payment_cash',
	step: 'payment_cash',
	sortingWeight: 940
}

const statusPaymentPos = {
	text: json_lang.order_status.payment_pos,
	style: 'payment_pos',
	step: 'payment_pos',
	sortingWeight: 940
}

const statusPaymentValidate = {
	text: json_lang.order_status.payment_to_validate,
	style: 'payment_to_validate',
	step: 'payment_to_validate',
	sortingWeight: 900
}


const statusAssigned = {
	// text: json_lang.order_status.assigned, //TODO: por ahora se cambia a started
	text: json_lang.order_status.started,
	style: 'unconfirmed',
	step: 'unconfirmed',
	sortingWeight: 800
}
const statusUnAssigned = {
	text: json_lang.order_status.unassigned,
	style: 'canceled',
	step: 'canceled',
	sortingWeight: 800
}
const statusUnconfirmed = {
	text: json_lang.order_status.unconfirmed,
	style: 'unconfirmed',
	step: 'unconfirmed',
	sortingWeight: 800
}

const statusUnavailable = {
	text: json_lang.order_status.unavailable,
	style: 'unconfirmed',
	step: 'unconfirmed',
	sortingWeight: 700
}
const statusNotApply = {
	text: json_lang.order_status.not_apply,
	style: 'unconfirmed',
	step: 'unconfirmed',
	sortingWeight: 700
}

const orderHasFlag = (status, mapFilters) => mapFilters[status]

export const feeRulesType = (feeRules) => {
	if(feeRules.startsWith('good')){
		const splitedGoodType = feeRules.split('.');
		return splitedGoodType[1];
	}
	if(feeRules === 'good' || feeRules === 'quantity'){
		return null;
	}
	if(feeRules === 'sum'){
		return 'sum_quantity';
	}
	return feeRules;
};

/*const orderStatus = (status,isforDelivery) => {
	let forDelivery = isforDelivery;//a domicilio?
	let orderStatus = parseInt(status,10);
	let isService = ((status & MASK_SERVICE_TYPE) === TYPE_SERVICES);


	if((orderStatus & CANCELLED) === CANCELLED){
		return (statusCanceled)//1500
	}

	if((orderStatus & CANCELLED) === COMPLETED){
		return (statusDelivered)//1400
	}

	if ( isService && (orderStatus & FLAG_WORKING) === FLAG_WORKING) {
		return statusInProgress
	}

	if((orderStatus & TARGET_REACHED) === TARGET_REACHED){//1300
		if(isService){
			return (statusInProgress)
		}else{
			if (forDelivery) {
			    return (statusArrived)
			} else {
			    return (statusReady)
			}
		}
	}

	if((orderStatus & RUNNING) === RUNNING){//1200
		if (isService) {
		    if (forDelivery) {
		        return (statusOnTheWay)
		    } else {
		       //The service is ready to be executed. Waiting for Client
		        return (statusOnTheWay)
		    }
		} else {
		    if (forDelivery) {
		    	if((orderStatus & ASSIGNED) === ASSIGNED){
			    	return (statusInProgress2)
		    	}else{
		    		return (statusDelayed)//1211
		    	}
			}else{
				return (statusInProgress)
			}
		}
	}

	if ((orderStatus & ACCEPTED) === ACCEPTED) {//1000
        //The payment was approved
        if (isService) {
            if (forDelivery) {
                if ((orderStatus & PENDING) === 0) {
                    return (statusScheduled)
                } else {
                    return (statusConfirmed)
                }
            } else {
                if ((orderStatus & PENDING) === 0) {
                    return (statusScheduled)
                } else {
                    return (statusConfirmed)
                }
            }
        } else {
            if (forDelivery) {
                if ((orderStatus & PENDING) === 0) {
                    return (statusScheduled)
                } else {
                    return (statusConfirmed)
                }
            } else {
                return (statusConfirmed)
            }
        }
    }

    if ((orderStatus & UNCONFIRMED) === UNCONFIRMED) {//800
        return (statusUnconfirmed)
    }

	if ((orderStatus & WAITING_PAYMENT) === WAITING_PAYMENT) {//900
	    return (statusPaymentValidate)//940
	} else {
	    return (statusPaymentPending)
	}
}*/


const orderStatus = (status,isforDelivery,currentStatus=0) => {
	let forDelivery = isforDelivery;//a domicilio?
	let orderStatus = parseInt(status,10);
	let isService = ((status & MASK_SERVICE_TYPE) === TYPE_SERVICES);
	currentStatus = (currentStatus === 0) ? orderStatus : parseInt(currentStatus,10);
	let adminType = store.getState().session && store.getState().session.admin_type && store.getState().session.admin_type.id


	if( store.getState().userHigherAccess !== COMPANY_ACCESS && adminType !== 2){
		if((orderStatus & COLLECTED) !== 0){
			return statusDispatched2
		}else if((orderStatus & PREPARED) !== 0){
			return statusPrepared
		}else if((orderStatus & BEING_PREPARED) !== 0){
			return statusBeingPrepared
		}else if( ( (orderStatus & (POST_PAYMENT|ACCEPTED) ) !== 0 ) && (orderStatus & (COMPLETED) )  === 0  ){
			return statusIsConfirmed
		}else if((orderStatus & CANCELLED) === CANCELLED){
			return (statusCanceled)
		}else{
			return (statusUnavailable)
		}

	}else{
		//console.log("orderStatus",adminType)
		if((orderStatus & CANCELLED) === CANCELLED){
			if(( currentStatus & TARGET_REACHED) === TARGET_REACHED ){
				return (statusNotDelivered)
			}
			if(( orderStatus & EXPIRED) === EXPIRED ){
				return (statusExpired)
			}
			return (statusCanceled)//1500
		}

		if((orderStatus & CANCELLED) === COMPLETED){
			return (statusDelivered)//1400
		}

		if ( isService && (orderStatus & FLAG_WORKING) === FLAG_WORKING) {
			return statusInProgress
		}

		if((orderStatus & TARGET_REACHED) === TARGET_REACHED){//1300
			if(isService){
				return (statusInProgress)
			}else{
				if (forDelivery) {
				    return (statusArrived)
				} else {
				    return (statusReady)
				}
			}
		}

		if (( orderStatus & COLLECTED) === COLLECTED) {
			return statusOnTheWay
		}

		if (( orderStatus & READY_TO_COLLECT) === READY_TO_COLLECT) {
			return statusInCommerce //statusOnTheWay //statusProviderArrived
		}

		if((orderStatus & RUNNING) === RUNNING){//1200
			if (isService) {
			    if (forDelivery) {
			        return (statusOnTheWay)//statusInProgress2
			    } else {
			       //The service is ready to be executed. Waiting for Client
			        return (statusOnTheWay)//statusInProgress2
			    }
			} else {
			    if (forDelivery) {
			    	if((orderStatus & ASSIGNED) === ASSIGNED){
				    	return (statusAssigned)//statusInProgress2
			    	}else{
			    		return (statusDelayed)//1211
			    	}
				}else{
					return (statusInProgress)
				}
			}
		}

		////////////////////////////////////////////
		if (( orderStatus & PREPARED) === PREPARED) {
			return statusPrepared
		}

		if (( orderStatus & BEING_PREPARED) === BEING_PREPARED) {
			return statusBeingPrepared
		}
		///////////////////////////////////////////
		if ( (( orderStatus & ASSIGNED) === ASSIGNED ) && (orderStatus !== currentStatus)) {
			return statusAssigned
		}

	    if ((orderStatus & UNCONFIRMED) === UNCONFIRMED) {//800
	        return (statusUnconfirmed)
	    }else{
	    	return statusIsConfirmed
	    }
	}
}

const orderBranchStatus = (status,isforDelivery,currentStatus=0) => {
	let orderStatus = parseInt(status,10);
	currentStatus = (currentStatus === 0) ? orderStatus : parseInt(currentStatus,10);
	if((orderStatus & COLLECTED) !== 0){
		return statusDispatched2
	}else if((orderStatus & PREPARED) !== 0){
		return statusPrepared
	}else if((orderStatus & BEING_PREPARED) !== 0){
		return statusBeingPrepared
	}else if( ( (orderStatus & (POST_PAYMENT|ACCEPTED) ) !== 0 ) && (orderStatus & (COMPLETED) )  === 0  ){
		// Esta entrando
		return statusNotStarted
	}else if((orderStatus & CANCELLED) === CANCELLED){
		return (statusCanceled)
	}else{
		return statusNotStarted //(statusUnavailable)
	}
}

const orderStatusPayment = (status,isforDelivery,orderDetails) => {
	let forDelivery = isforDelivery;//a domicilio?
	let orderStatus = parseInt(status,10);
	let isService = ((status & MASK_SERVICE_TYPE) === TYPE_SERVICES);

	if ((orderStatus & ACCEPTED) === ACCEPTED) {//1000
        //The payment was approved
        if (isService) {
            if (forDelivery) {
                if ((orderStatus & PENDING) === 0) {
                    return (statusScheduled)
                } else {
                    return (statusConfirmed)
                }
            } else {
                if ((orderStatus & PENDING) === 0) {
                    return (statusScheduled)
                } else {
                    return (statusConfirmed)
                }
            }
        } else {
            if (forDelivery) {
                if ((orderStatus & PENDING) === 0) {
                    return (statusScheduled)
                } else {
                    return (statusConfirmed)
                }
            } else {
                return (statusConfirmed)
            }
        }
    }

	if ((orderStatus & (WAITING_PAYMENT|POST_PAYMENT|ACCEPTED)) === WAITING_PAYMENT) {//900
	    return (statusPaymentValidate)//940
	} 
	// else if((orderStatus & POST_PAYMENT) === POST_PAYMENT){
	// 	if(orderDetails
	// 		&& orderDetails.selected_payment_method
	// 		&& orderDetails.selected_payment_method.id){
	// 		return (statusPaymentPos)
	// 	}
	// 	 return (statusPaymentCash)
	// }
	else {
	    return (statusPaymentPending)
	}
}

const orderStatusPaymentMethod = (method, selectedPayment, orderStatus, total) => {
	if(method && method.length > 0){
		const filteredSuccessful = method.filter(payment => payment.status === "successful");
		if(filteredSuccessful.length > 1){
			const paymentType = filteredSuccessful.map(payment => payment.related_payment_name === "bancamiga_ci" ? "bancamiga" : payment.type);
			const paymentTitle = filteredSuccessful.map(payment =>{ 
				let text = MaysPrimera(payment.related_payment_name);
				if(payment.related_payment_name === "bancamiga_ci"){
					text = "Bancamiga CI";
				}
				if(payment.related_payment_name === "balance"){
					text = "ZupperCredits";
				}
				return text;
			});
			return statusPaymentMixed(paymentType, paymentTitle.join(", "));
		} else if(filteredSuccessful.length === 1 && orderStatus && ((orderStatus & POST_PAYMENT) === POST_PAYMENT) && selectedPayment){
			const isOrderFullyPaid = filteredSuccessful[0].total_e2 >= total;

			if(filteredSuccessful[0].type === "pos" || filteredSuccessful[0].type === "payment_pos"){
				return statusPaymentPos;
			}else if(filteredSuccessful[0].type === "efectivo" || filteredSuccessful[0].type === "payment_cash"){
				return statusPaymentCash;
			}
			let text = MaysPrimera(filteredSuccessful[0].related_payment_name);
			if(filteredSuccessful[0].related_payment_name === "bancamiga_ci"){
				text = "Bancamiga CI";
			}
			if(filteredSuccessful[0].related_payment_name === "balance"){
				text = "ZupperCredits";
			}

			if(isOrderFullyPaid){
				return {
					text,
					style: filteredSuccessful[0].related_payment_name === "bancamiga_ci" ? "bancamiga" : filteredSuccessful[0].type
				};
			}

			if(selectedPayment.id){
				const posPaymentType = [
					statusPaymentPos.style,
					filteredSuccessful[0].related_payment_name === "bancamiga_ci" ? "bancamiga" : filteredSuccessful[0].type
				]
				return statusPaymentMixed(posPaymentType, `${statusPaymentPos.text}, ${text}`);
			} else {
				const cashPaymentType = [
					statusPaymentCash.style,
					filteredSuccessful[0].related_payment_name === "bancamiga_ci" ? "bancamiga" : filteredSuccessful[0].type
				]
				return statusPaymentMixed(cashPaymentType, `${statusPaymentCash.text}, ${text}`);
			}
		} else {
			const lastPayment= method[0];
			switch(lastPayment.status){
			case "successful":
				let text = MaysPrimera(lastPayment.related_payment_name);
				let style = lastPayment.type;
				if(lastPayment.related_payment_name === "balance"){
					text = "ZupperCredits";
				}
				if(lastPayment.related_payment_name === "bancamiga_ci"){
					text = "Bancamiga CI";
					style = "bancamiga";
				}
				return {
					text: text,
					style: style
				};
			case "pending_confirmation":
				return statusPaymentPending;
			case "refused_invalid":
				return statusPaymentRefusedInvalid;
			case "refused_duplicated":
				return statusPaymentRefusedDuplicated;
			default:
				return statusPaymentPending;
			}
		}
	} else if(orderStatus && ((orderStatus & POST_PAYMENT) === POST_PAYMENT) && selectedPayment){
		if(selectedPayment.id){
			return statusPaymentPos;
		} else {
			return statusPaymentCash;
		}
	} else {
		return statusPaymentPending;
	}
}

const orderStatusProvider = (status) => {
	if(status){
		switch (status) {
			case 'CANCELED':
				return statusCanceled;
			case 'DELIVERED':
				return statusDelivered;
			case 'ARRIVED':
				return statusArrived;
			case 'DELAYED':
				return statusDelayed;
			case 'ON_THE_WAY':
				return statusOnTheWay;
			case 'NOT_ASSIGNED':
				return statusUnAssigned;
			case 'COLLECTING':
				return statusInCommerce;
			case 'STARTED':
				return statusInProgress;
			case 'ASSIGNED':
				return statusAssigned;
				// TODO! STATUS DE SHOPPER, DESPUES BORRAR
			case 'PREPARED':
				return statusPrepared;
			case 'BEING_PREPARED':
				return statusBeingPrepared;
			case 'WAITING_PAYMENT':
				return statusPaymentPending;
				// TODO! FIN DE STATUS SHOPPER
			default:
				return statusNotApply;
		}
	} else {
		return statusUnavailable;
	}
}

const orderStatusShopper = (status) => {
	if(status){
		switch (status){
			case 'CANCELED':
				return statusCanceled;
			case 'DELIVERED':
				return statusDelivered;
			case 'PREPARED':
				return statusPrepared;
			case 'BEING_PREPARED':
				return statusBeingPrepared;
			case 'ON_THE_WAY':
				return statusOnTheWay;
			case 'NOT_ASSIGNED':
				return statusUnAssigned;
			case 'WAITING_PAYMENT':
				return statusPaymentPending;
			case 'ASSIGNED':
				return statusAssigned;
			default:
				return statusNotApply;
		}
	} else {
		return statusUnavailable;
	}
}

const MaysPrimera= (string) =>{
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/*const zerofilled=(num, length, character)=>{
	var pad_char = typeof character !== 'undefined' ? character : '0';
	var pad = new Array(1 + length).join(pad_char);
	return (pad + num).slice(-pad.length);
}*/
const zerofilled = (number, width)=> {
    var numberOutput = Math.abs(number); /* Valor absoluto del número */
    var length = number.toString().length; /* Largo del número */
    var zero = "0"; /* String de cero */

    if (width <= length) {
        if (number < 0) {
            return ("-" + numberOutput.toString());
        } else {
            return numberOutput.toString();
        }
    } else {
        if (number < 0) {
            return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
        } else {
            return ((zero.repeat(width - length)) + numberOutput.toString());
        }
    }
}

const number_format =( number, decimals, dec_point, thousands_sep ) => {
    let defaultDecimals = store.getState().currencies.local.decimals_count || 2;
	var n = number, c = isNaN(decimals = Math.abs(decimals)) ? defaultDecimals : decimals;
	var d = dec_point === undefined ? /*","*/"." : dec_point;
	var t = thousands_sep === undefined ? "." : thousands_sep, s = n < 0 ? "-" : "";
	var i = parseInt(n = Math.abs(+n || 0).toFixed(c),10) + "";
	let j;
	j = (j = i.length) > 3 ? j % 3 : 0;

	return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

const validate_number = (evt) => {
    var nav4=window.Event?true:false;
    var key=nav4 ? evt.which : evt.keyCode;
	return (key<=13 || key===127 || key===46 || (key>=48 && key<=57)||key === 180 ||key === 190 ||key === 44) ? true: evt.preventDefault();
}

const b64toBlob =(b64Data, contentType, sliceSize)=> {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

	var blob = new Blob(byteArrays, {type: contentType});
	return blob;
}


const fixBinary =  (bin) => {
	let length = bin.length;
	let buf = new ArrayBuffer(length);
	let arr = new Uint8Array(buf);
	for (var i = 0; i < length; i++) {
		arr[i] = bin.charCodeAt(i);
	}
	return buf;
}

const isPickUp =(clientLatitude, clientLongitude, clientAddress)=> {
	return parseInt(clientLatitude,10) === 0 && parseInt(clientLongitude,10) === 0 && clientAddress === null;
}

const moneySymbol =(iso)=> {
	/*if(iso){
		var symbolKey = currencyListEn.findIndex(( item ) => item.value === iso )
		return currencyListEn[symbolKey].symbol;
	}*/
	return iso
}

const moneyFullName =(iso)=> {

	if(iso){
		//var currencies= localStorage.getItem('lang_code') === 'es' ? currencyListEs : currencyListEn;
		//var symbolKey = currencies.findIndex((item) => item.value === iso);
		//console.log("iso",iso,symbolKey)
		return iso;//`${currencies[symbolKey].name} (${currencies[symbolKey].symbol})`;
	}
}

const moneySymbolNative =(iso)=> {
	if(iso){
		var symbolKey = currencyListEn.findIndex(( item ) => item.value === iso )
		return currencyListEn[symbolKey].symbol_native;
	}
	return iso
}

const utcDateFormat = (date,format='DD-MM-YYYY')=> {
	if( moment.locale() !== localStorage.getItem('lang_code') ){
		moment.updateLocale( localStorage.getItem('lang_code') )
	}
	var utcDate = moment.utc(date).utcOffset(store.getState().company.time_zone_offset || DEFAULT_TIME_ZONE)
	return format === 'fromNow' ? utcDate.format("DD MMM YYYY hh:mm a") : utcDate.format(format)
}

const utcConvertion = (date, type = "start", format = "YYYY-MM-DD HH:mm:ss") => {
	const companyTimeZone = store.getState().company.time_zone_offset || DEFAULT_TIME_ZONE;
	const formatedDate = moment.utc(date).utcOffset(companyTimeZone);
	if(type === "start"){
		return formatedDate.startOf('day').utc().format(format)
	} else if (type === "end"){
		return formatedDate.endOf('day').utc().format(format)
	} else if (type === "custom"){
		return formatedDate.utc().format(format)
	}
}

const utcToLocal = (utcTimeString, format = "HH:mm") => {
	const companyTimeZone = store.getState().company.time_zone_offset || DEFAULT_TIME_ZONE;
	return moment.utc(utcTimeString, "HH:mm").utcOffset(companyTimeZone).format(format);
  };
  

const truncateString = (string, maxLength = 20) => {
	if (string.length > maxLength) {
        return string.slice(0, maxLength) + '...';
    }
    return string;

}

const utcHours2LocalHours = (date, backwards = false) => {
	if (moment.locale() !== localStorage.getItem('lang_code')) {
		moment.updateLocale(localStorage.getItem('lang_code'))
	}

	let time = moment(date, "HH:mm")
	let hours = moment.utc(time).utcOffset(store.getState().company.time_zone_offset || DEFAULT_TIME_ZONE);

	return backwards ? hours.utc().format("HH:mm") : hours.utc(hours).local().format("HH:mm")
}

const dimenImg = (url,dimension,ext)=> {
	return url.replace(/\.([^\.]*)$/, '-'+dimension+'.' + (ext ? ext : '$1') );
}

const providerOnline = (status)=> {
	return (parseInt(status,10)&48) === 16;
}

const providerIsBussy = (status)=> {
	return (parseInt(status,10)&3) === 2;
}
const FloatPrecision = (x)=> {
	return Number.parseFloat(x).toPrecision(4)
}

const imageLoaderHandler = (ev, image, size, format, defaultImg) => {
	/*
		Al dar error la imagen, yo necesito comprar tiempo para que el cdn o el mal internet del usr me traigan el archivo...
		Entonces le agrego al img un atributo RETRIES y cada 20 seg intento buscar esa imagen del cdn/recortada mientras el api termina de procesarla
	*/
	let target = ev.target;

	// va iterando del 0 al 2
	if (target.dataset.retries < "3") {
		// primero le doy la imagen por defecto para que le muestre algo al usr mientras
		target.src = image;
		const src = target.src;

		setTimeout(() => {
			// incremento el numero de intentos q lleva
			target.dataset.retries = parseInt(target.dataset.retries,10) + 1;

			// luego de estos segundos le pongo la imagen recortada para ver si da error
			// y le agrego a la url "?1"  ese signo de interrogacion y lo q venga luego es para saltar la cache del navegador
			target.src = dimenImg(src, size, format) + "?" + target.dataset.retries;

		}, 20000);

	} else {
		// si esta en produccion y llego a los 3 intentos fallido quitale el cdn es el principal culpable de q falle, cuando el usr llegue otro dia, ya seguro existira la imagen
		if(process.env.REACT_APP_ENV === "PRODUCTION"){
			target.src = target.src.replace(".cdn", "");
			target.dataset.retries = parseInt(target.dataset.retries, 10) + 1;
		}
		// si la imagen existe pero ha dado muchos errores muestra la pesada no importa
		else if (
				// si falla en el if anterior, pasa la siguiente condicion
				(process.env.REACT_APP_ENV === "PRODUCTION" && target.dataset.retries === "4")
				// si no estas en produccion pasa esta
			 	|| target.dataset.retries === "3"
			) {
			target.dataset.retries = parseInt(target.dataset.retries, 10) + 1;
			target.src = image;
		}
		// si la cuestion es q la imagen no existe/internet o XYZ ponle la imagen por defecto
		else {
			target.src = defaultImg;
		}
	}
}

const couponStatus = (status) => {
	let couponStatus = {
		sortingWeight: 1,
		style: "canceled", //"delivered",
		text: json_lang.common.finished
	}
	if (status === "running") {
		couponStatus = {
			sortingWeight: 2,
			style: "delivered", //"ready",
			text: json_lang.common.running
		}
	}
	if (status === "pending") {
		couponStatus = {
			sortingWeight: 3,
			style: "ready",
			text: json_lang.common.pending
		}
	}
	if (status === "generating") {
		couponStatus = {
			sortingWeight: 5,
			style: "ready",
			text: json_lang.common.generating
		}
	}
	if (status === "ready") {
		couponStatus = {
			sortingWeight: 6,
			style: "delivered",
			text: json_lang.common.ready
		}
	}

	return couponStatus;
}


const setMin =(min,option) => {
  let v = (min << 20);
  return option ^= ((option ^ v) & 0x00f00000);//modifica el options real
}

const getMin =(option) => {
  return (option & 0x00f00000) >> 20;//extrae del options real
}

const setMax =(max,option) => {
  let v = (max << 16);
  return option ^= ((option ^ v) & 0x000f0000);//modifica el options real
}

const getMax =(option) => {
  return (option & 0x000f0000) >> 16;//extrae del options real
}

const setStack =(stack,option) => {
  let v = (stack << 24);
  return option ^= ((option ^ v) & 0x00f000000);//modifica el options real
}

const getStack =(option) => {
  return (option & 0x00f000000) >> 24;//extrae del options real
}

const regexGetNumber =(text) => {
	const regexp = /[0-9]+/g;
	const str = text;
	let numbers = [...str.matchAll(regexp)].map((num) => parseInt(num,10))
	return numbers
}

const regexValidateUserName =(text) => {
	const str = text;
	const regexp = /[.-]+/g;
	let validate = regexp.test(str);
	return validate
}

const nameValidateRegex = (txt) => {
	let validate = new RegExp(/^([\p{L} ,']*)$/, 'u').test(txt);
    return validate;
}

const toPaginate = (data, limit = 12, last_page = 223) => {
    return {
		"current_page": 1,
		"data": data,
		"first_page_url": "",
		"from": 1,
		"last_page": last_page,
		"last_page_url": "",
		"links": [],
		"next_page_url": "",
		"path": "",
		"per_page": limit,
		"prev_page_url": null,
		"to": limit,
		"total": data.length
	};
}

const localizedErrorHandler = (error) => {
	const errorBody = {
		code: error.error_code,
		message: error.description,
		details: error.details || null
	}
	if(error.localized_error && error.localized_error.spanish){
		errorBody.message = error.localized_error.spanish.message;
	}
	return errorBody;
}

const getBrightness = (color) => {
    color = color.replace('#', '');
    let r = parseInt(color.substring(0, 2), 16);
    let g = parseInt(color.substring(2, 4), 16);
    let b = parseInt(color.substring(4, 6), 16);
    return (r * 0.299 + g * 0.587 + b * 0.114);
}

const clone = (object) => {
	if(object === null){
		return null;
	}
	if (Array.isArray(object)) {
		return object.map(item => {
			return clone(item);
		});
	}
	if(typeof object === 'object') {
		const out = {};
		Object.keys(object).forEach(key => {
			out[key] = clone(object[key]);
		});
		return out;
	}
	return object;
}

const getPaymentMethodLogo = (paymentMethod) => {
    switch(paymentMethod){
        case "balance":
            return "https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/zupper-credits-48x48.svg";
		case "banco_de_venezuela":
		case "Transferencia bancaria":
		case "Transferencia Bancaria":
		case "transferencia-bancaria":
			return "https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/transferencia-48x48.svg";
		case "pago-movil":
		case "Pago Móvil":
		case "Pago móvil Automatizado":
			return "https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/pago-movil-48x48.svg";
        case "binance":
            return "https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/binance-48x48.svg";
        case "paypal":
        case "Paypal":
            return "https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/paypal-48x48.svg";
        case "stripe":
            return "https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/tdc-internacional-48x48.svg";
        case "pos":
        case "POS":
        case "payment_pos":
		case "Zupper POS":
		case "post-payment":
            return "https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/pos-icon-48x48.svg";
        case "bancamiga_ci":
        case "bancamiga-ci":
		case "bancamiga":
            return "https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/debito-inmediato-48x48.svg";
		case "zelle":
            return "https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/zelle-48x48.svg";
        default:
            return "https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/efectivo-48x48.svg";
    }
}

const tempoConverter = (minutes) => {
	if(minutes === 0)
		return "pocos segundos";

	if (minutes < 60)
		return `${minutes} minuto${minutes !== 1 ? 's' : ''}`;

	const hours = Math.floor(minutes / 60);
	const remainingMinutes = Math.floor((minutes % 60));

	if(hours < 24)
		return remainingMinutes > 0 ? `${hours} hora${hours !== 1 ? 's' : ''} y ${remainingMinutes} minuto${remainingMinutes !== 1 ? 's' : ''}` : `${hours} hora${hours !== 1 ? 's' : ''}`;

	const days = Math.floor(hours / 24);
	const remainingHours = Math.floor(hours % 24);
	if(days < 30)
		return `${days} dia${days !== 1 ? 's' : ''} y ${remainingHours} hora${remainingHours !== 1 ? 's' : ''}`;

	const months = Math.floor(days / 30);
	if(months < 12)
		return `${months} mes${months !== 1 ? 'es' : ''}`;
	
	const years = Math.floor(months / 12);
	const remainingMonths = Math.floor(months % 12);
	return `${years} año${years !== 1 ? 's' : ''} y ${remainingMonths} mes${remainingMonths !== 1 ? 'es' : ''}`;
}

const formatPromoInfo = (promo_info) => {
	if (!promo_info) return "";
  
	const isCustom = promo_info.startsWith("!");
	const isPercentStar = promo_info.startsWith("%");
	const isPercentEnd = promo_info.endsWith("%");
	const isPercent = isPercentStar || isPercentEnd;
  
	const isRelative = promo_info.startsWith("<");
  
	if (isCustom) return promo_info.substring(1);
	if (isRelative) return `Hasta ${promo_info.substring(1)} off`;
	if (isPercent) return isPercentStar ? `${promo_info.substring(1)}% off` : `${promo_info} off`;
  
	return `-${promo_info}$`;
  };

export {
	toPaginate,
	nameValidateRegex,
	fixBinary,
	regexValidateUserName,
	regexGetNumber,
	utcHours2LocalHours,
	setMin,
	getMin,
	setMax,
	getMax,
	setStack,
	getStack,
	orderStatus,
	couponStatus,
	MaysPrimera,
	zerofilled,
	imageLoaderHandler,
	number_format,
	validate_number,
	b64toBlob,
	orderHasFlag,
	isPickUp,
	moneySymbol,
	moneyFullName,
	moneySymbolNative,
	utcDateFormat,
	utcConvertion,
	utcToLocal,
	truncateString,
	orderStatusPayment,
	orderStatusPaymentMethod,
	orderStatusProvider,
	orderStatusShopper,
	dimenImg,
	providerOnline,
	providerIsBussy,
	FloatPrecision,
	orderBranchStatus,
	getBrightness,
	clone,
	localizedErrorHandler,
	tempoConverter,
	getPaymentMethodLogo,
	formatPromoInfo
	//statusList
};



// WEBPACK FOOTER //
// ./src/store/actions/UtilsOperation.js